// extracted by mini-css-extract-plugin
export default {"singleCard":"PQyyawfI","scrollerItem":"ZO6oCxsr"};